import swRegister from './sw-client-side/service-worker-registration';

swRegister();
